import React from 'react';
import { Box } from '@mui/material';
import Text from '../Text';
import ScrollReveal from '../animated/ScrollReveal';
import { colors, radii, shadows } from '../../theme/designTokens';
import irdaiCertificate from '../../assets/images/irdai-certificate.png';

const IrdaCertificateSection = () => (
  <Box
    sx={{
      px: { xs: 2, sm: 3, md: 4 },
      py: { xs: 4, md: 5 },
      background: colors.offWhite,
    }}
  >
    <Box sx={{ maxWidth: 560, mx: 'auto', textAlign: 'center' }}>
      <ScrollReveal>
        <Text variant="h3" color="primary" sx={{ mb: 2, display: 'block' }}>
          IRDA licensed
        </Text>
      </ScrollReveal>

      <ScrollReveal delay={0.08}>
        <Box
          sx={{
            width: '100%',
            p: 0.75,
            borderRadius: radii.md,
            background: colors.white,
            border: `1px solid ${colors.borderLight}`,
            boxShadow: shadows.sm,
            overflow: 'hidden',
          }}
        >
          <Box
            component="img"
            src={irdaiCertificate}
            alt="IRDA Certificate of Renewal of Registration — ALEgION Insurance Broking Pvt Ltd"
            decoding="async"
            loading="lazy"
            sx={{
              display: 'block',
              width: '100%',
              height: 'auto',
              borderRadius: radii.sm,
            }}
          />
        </Box>
      </ScrollReveal>
    </Box>
  </Box>
);

export default IrdaCertificateSection;
